import gsap from 'gsap';

const selectors = {
  el: '.js-pamplemousse-sit:not(.is-initialized)',
};

const init = () => {
  const els = document.querySelectorAll(selectors.el);

  els.forEach(el => {
    el.classList.add('is-initialized');

    const eyes = el.querySelector('#eyes');
  
    const eyesBlinkTl = gsap.timeline({
      repeat: -1,
    });
    eyesBlinkTl
      .to(
        eyes,
        {
          scaleY: 0,
          duration: 0.05,
          transformOrigin: '50% 35%',
        },
        '+=5',
      )
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      })
      .to(
        eyes,
        {
          scaleY: 0,
          duration: 0.05,
          transformOrigin: '50% 35%',
        },
        '+=5',
      )
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      })
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      })
      .to(
        eyes,
        {
          scaleY: 0,
          duration: 0.05,
          transformOrigin: '50% 35%',
        },
        '+=5',
      )
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      })
      .to(
        eyes,
        {
          scaleY: 0,
          duration: 0.05,
          transformOrigin: '50% 35%',
        },
        '+=.1',
      )
      .to(eyes, {
        scaleY: 1,
        duration: 0.05,
        transformOrigin: '50% 35%',
      });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
